module.exports = __webpack_public_path__ + "static/media/construccion.26372b64.png";